const actions = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_ERROR: "LOGIN_ERROR",

  RESET_ACTIONTYPE: "RESET_ACTIONTYPE",

  login: (url,body) => ({
    type: actions.LOGIN_REQUEST,
    payload: { url,body },
  }),

  resetActionType: () => ({
    type: actions.RESET_ACTIONTYPE,
  }),
};

export default actions;
